import React, { useState } from 'react'
import { useFormik } from 'formik'
import { Grid, Box, Heading, Text, Link, Button } from '@chakra-ui/react'
import * as Yup from 'yup'

import { Link as RouterLink } from '@/lib/Link'

import { withAuthPage } from '../components/withAuthPage'
import { ForgotForm } from '@/features/auth/components'

import * as AuthServices from '@/lib/auth/AuthServices'
import getErrorMsg from '@/lib/helpers/getErrorMsg'
import { NextSeo } from 'next-seo'

function Forgot() {
  const [errorMsg, setErrorMsg] = useState('')
  const [success, setSuccess] = useState(false)

  const handleSubmit = async (values, actions) => {
    const { email } = values
    try {
      await AuthServices.forgotPassword({ email })
      setSuccess(true)
    } catch (err) {
      const error = getErrorMsg(err)
      setErrorMsg(error)
      actions.setSubmitting(false)
    }
  }

  const formProps = useFormik({
    validateOnChange: false,
    initialValues: { email: '' },
    onSubmit: handleSubmit,
    validationSchema,
  })

  return (
    <React.Fragment>
      <NextSeo title="Forgot Password" />

      {success ? (
        <ForgotSuccess email={formProps.values.email} />
      ) : (
        <Grid textAlign="center" pb="32px">
          <Box p="36px 0 23px" borderBottom="1px solid #e8e8e8">
            <Heading fontSize="2xl" mb="8px">
              ลืมรหัสผ่าน
            </Heading>
            <Text m="0 auto" fontSize="sm">
              กรอกอีเมลที่ลงทะเบียนบัญชีไว้ เพื่อทำการล้างค่ารหัสผ่านใหม่
            </Text>
          </Box>

          <Box mb="75px">
            <ForgotForm {...formProps} errorMsg={errorMsg} />

            <Text fontSize="sm">
              มีบัญชีอยู่แล้ว?&nbsp;
              <Link as={RouterLink} route="login">
                เข้าสู่ระบบ
              </Link>
            </Text>
          </Box>

          <Text fontSize="xs">
            <Link as={RouterLink} route="terms">
              ข้อตกลงการใช้บริการ
            </Link>
            &nbsp;และ&nbsp;
            <Link as={RouterLink} route="privacy">
              นโยบายการรักษาข้อมูลส่วนตัว
            </Link>
          </Text>
        </Grid>
      )}
    </React.Fragment>
  )
}

export default withAuthPage()(Forgot)

const ForgotSuccess = (props) => {
  const { email } = props

  return (
    <Grid justifyItems="center" p="80px 80px 50px" textAlign="center">
      <div
        css={{
          marginBottom: '20px',
          width: '80px',
          height: '80px',
          background:
            'no-repeat center/contain url(/icons/correct-circle-icon.svg)',
        }}
      />
      <Text fontSize="2xl" mb="8px">
        ส่งลิงก์สำหรับการตั้งรหัสใหม่ให้คุณแล้ว
      </Text>
      <Text mb="24px">
        โปรดตรวจสอบอีเมล <strong>{email}</strong>&nbsp;
        หากคุณมีบัญชีกับเราคุณจะได้รับลิงก์ เพื่อตั้งรหัสผ่านใหม่ของคุณ
      </Text>
      <Text mb="32px">
        หากคุณไม่แน่ใจว่าอีเมลถูกต้องไหม หรือไม่ได้รับอีเมล โปรดติดต่อ
        ฝ่ายบริการลูกค้าของเรา
      </Text>
      <Link as={RouterLink} route="login">
        <Button w="260px" colorScheme="primary" variant="solid" size="lg">
          กลับหน้าเข้าสู่ระบบ
        </Button>
      </Link>
    </Grid>
  )
}

const validationSchema = Yup.object().shape({
  email: Yup.string()
    .email('Email is not valid')
    .required('Email should not be empty'),
})
